<template>
    <div>
        <span class="go-index" @click="gotoPage()">返回</span>
        
        <h2 style="margin: 2rem auto;text-align: center;">隐私保护声明</h2>
        <h3 style="margin: 2rem auto;text-align: center;padding-bottom: 1rem;border-bottom: 1px solid #efefef;">我们通过如下途径保护用户信息安全:</h3>
         <!-- <div style="background: #ffffff; margin-bottom: 0.1rem;" > -->

        <h4 style="padding:0.5rem 2rem 0 2rem;margin: 2rem auto 1rem auto;">存储安全保护</h4>
        <div style="background: #efefef;padding:0.5rem 0;">
            <p style="padding:0.5rem 2rem 0 2rem;font-size:.7rem;color:#999;">依托阿里云强大、成熟的网络安全防护能力，以及使用非对称加密存储以及信息脱敏机制，保障用户信息安全；</p>
        </div>

        <h4 style="padding:0.5rem 2rem 0 2rem;margin: 2rem auto 1rem auto;">管理以及使用流程</h4>
        <div style="background: #efefef;padding:0.5rem 0;">
            <p style="padding:0.5rem 2rem 0 2rem;font-size:.7rem;color:#999;">我们制定了用户信息接触权限制度，严格控制接触用户信息的内部人员范围，并恪守保护用户隐私的原则；</p>
            <p style="padding:0.5rem 2rem 0 2rem;font-size:.7rem;color:#999;">除法律规定或用户授权，我们承诺不将用户提交给任何第三方机构；</p>
        </div>

        <h4 style="padding:0.5rem 2rem 0 2rem;margin: 2rem auto 1rem auto;">用户注销流程</h4>
        <div style="background: #efefef;padding:0.5rem 0;">
            <p style="padding:0.5rem 2rem 0 2rem;font-size:.7rem;color:#999;">用户注销账户后，我们会按照法律相关规定处置或清空用户一切信息；</p>
        </div>
        
        
        
        <!-- 组件声明 -->
        <syalert ref="syalert_id" /> 
    </div>
</template>
<script>
    // 组件引入
    import syalert from '@/components/syalert.vue';

    export default {
        // 组件注册
        components: {
            syalert,
        },
        data() {
            return {
            }
        },
        methods: {
            gotoPage:function(page)
            {
                if( page !== undefined )
                {
                    this.$router.push(page);
                }else{
                    this.$router.go(-1);
                }
            },
            syalert_tip: function(msg) {
                // 组件调用
                this.$refs.syalert_id.syalert(msg);
            },
        },
        mounted() {
            // http.get(this.$root.API + '/User/UserCenter').then(rtn => {
            //     this.userInfo = rtn.data;
            //     console.log(rtn);
            // });
        }
    }

</script>
